import { Swiper as Q } from "swiper";
import { parseSlideDSL as R, compile as q } from "@slidejs/dsl";
import { SlideRunner as Z } from "@slidejs/runner";
function T(n) {
  return n !== null && typeof n == "object" && "constructor" in n && n.constructor === Object;
}
function G(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = {});
  const s = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((t) => s.indexOf(t) < 0).forEach((t) => {
    typeof n[t] > "u" ? n[t] = e[t] : T(e[t]) && T(n[t]) && Object.keys(e[t]).length > 0 && G(n[t], e[t]);
  });
}
const $ = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function F() {
  const n = typeof document < "u" ? document : {};
  return G(n, $), n;
}
const U = {
  document: $,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(n) {
    return typeof setTimeout > "u" ? (n(), null) : setTimeout(n, 0);
  },
  cancelAnimationFrame(n) {
    typeof setTimeout > "u" || clearTimeout(n);
  }
};
function P() {
  const n = typeof window < "u" ? window : {};
  return G(n, U), n;
}
function V(n) {
  return n === void 0 && (n = ""), n.trim().split(" ").filter((e) => !!e.trim());
}
function K(n, e) {
  e === void 0 && (e = "");
  const s = P(), t = [...n.children];
  return s.HTMLSlotElement && n instanceof HTMLSlotElement && t.push(...n.assignedElements()), e ? t.filter((d) => d.matches(e)) : t;
}
function J(n, e) {
  e === void 0 && (e = []);
  const s = document.createElement(n);
  return s.classList.add(...Array.isArray(e) ? e : V(e)), s;
}
function X(n) {
  const e = P(), s = F(), t = n.getBoundingClientRect(), d = s.body, a = n.clientTop || d.clientTop || 0, u = n.clientLeft || d.clientLeft || 0, m = n === e ? e.scrollY : n.scrollTop, w = n === e ? e.scrollX : n.scrollLeft;
  return {
    top: t.top + m - a,
    left: t.left + w - u
  };
}
function I(n) {
  let e = n, s;
  if (e) {
    for (s = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (s += 1);
    return s;
  }
}
function N(n, e) {
  const s = [];
  let t = n.parentElement;
  for (; t; )
    e ? t.matches(e) && s.push(t) : s.push(t), t = t.parentElement;
  return s;
}
function _(n, e, s) {
  const t = P();
  return n[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(t.getComputedStyle(n, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(t.getComputedStyle(n, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function E(n) {
  return (Array.isArray(n) ? n : [n]).filter((e) => !!e);
}
function O(n, e) {
  e === void 0 && (e = ""), typeof trustedTypes < "u" ? n.innerHTML = trustedTypes.createPolicy("html", {
    createHTML: (s) => s
  }).createHTML(e) : n.innerHTML = e;
}
function ee(n) {
  let {
    swiper: e,
    extendParams: s,
    on: t,
    emit: d
  } = n;
  const a = F(), u = P();
  e.keyboard = {
    enabled: !1
  }, s({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function m(S) {
    if (!e.enabled) return;
    const {
      rtlTranslate: v
    } = e;
    let h = S;
    h.originalEvent && (h = h.originalEvent);
    const k = h.keyCode || h.charCode, p = e.params.keyboard.pageUpDown, l = p && k === 33, g = p && k === 34, f = k === 37, i = k === 39, r = k === 38, o = k === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && i || e.isVertical() && o || g) || !e.allowSlidePrev && (e.isHorizontal() && f || e.isVertical() && r || l))
      return !1;
    if (!(h.shiftKey || h.altKey || h.ctrlKey || h.metaKey) && !(a.activeElement && (a.activeElement.isContentEditable || a.activeElement.nodeName && (a.activeElement.nodeName.toLowerCase() === "input" || a.activeElement.nodeName.toLowerCase() === "textarea")))) {
      if (e.params.keyboard.onlyInViewport && (l || g || f || i || r || o)) {
        let c = !1;
        if (N(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && N(e.el, `.${e.params.slideActiveClass}`).length === 0)
          return;
        const C = e.el, M = C.clientWidth, Y = C.clientHeight, A = u.innerWidth, L = u.innerHeight, b = X(C);
        v && (b.left -= C.scrollLeft);
        const D = [[b.left, b.top], [b.left + M, b.top], [b.left, b.top + Y], [b.left + M, b.top + Y]];
        for (let x = 0; x < D.length; x += 1) {
          const y = D[x];
          if (y[0] >= 0 && y[0] <= A && y[1] >= 0 && y[1] <= L) {
            if (y[0] === 0 && y[1] === 0) continue;
            c = !0;
          }
        }
        if (!c) return;
      }
      e.isHorizontal() ? ((l || g || f || i) && (h.preventDefault ? h.preventDefault() : h.returnValue = !1), ((g || i) && !v || (l || f) && v) && e.slideNext(), ((l || f) && !v || (g || i) && v) && e.slidePrev()) : ((l || g || r || o) && (h.preventDefault ? h.preventDefault() : h.returnValue = !1), (g || o) && e.slideNext(), (l || r) && e.slidePrev()), d("keyPress", k);
    }
  }
  function w() {
    e.keyboard.enabled || (a.addEventListener("keydown", m), e.keyboard.enabled = !0);
  }
  function B() {
    e.keyboard.enabled && (a.removeEventListener("keydown", m), e.keyboard.enabled = !1);
  }
  t("init", () => {
    e.params.keyboard.enabled && w();
  }), t("destroy", () => {
    e.keyboard.enabled && B();
  }), Object.assign(e.keyboard, {
    enable: w,
    disable: B
  });
}
function W(n, e, s, t) {
  return n.params.createElements && Object.keys(t).forEach((d) => {
    if (!s[d] && s.auto === !0) {
      let a = K(n.el, `.${t[d]}`)[0];
      a || (a = J("div", t[d]), a.className = t[d], n.el.append(a)), s[d] = a, e[d] = a;
    }
  }), s;
}
function ie(n) {
  let {
    swiper: e,
    extendParams: s,
    on: t,
    emit: d
  } = n;
  s({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function a(p) {
    let l;
    return p && typeof p == "string" && e.isElement && (l = e.el.querySelector(p) || e.hostEl.querySelector(p), l) ? l : (p && (typeof p == "string" && (l = [...document.querySelectorAll(p)]), e.params.uniqueNavElements && typeof p == "string" && l && l.length > 1 && e.el.querySelectorAll(p).length === 1 ? l = e.el.querySelector(p) : l && l.length === 1 && (l = l[0])), p && !l ? p : l);
  }
  function u(p, l) {
    const g = e.params.navigation;
    p = E(p), p.forEach((f) => {
      f && (f.classList[l ? "add" : "remove"](...g.disabledClass.split(" ")), f.tagName === "BUTTON" && (f.disabled = l), e.params.watchOverflow && e.enabled && f.classList[e.isLocked ? "add" : "remove"](g.lockClass));
    });
  }
  function m() {
    const {
      nextEl: p,
      prevEl: l
    } = e.navigation;
    if (e.params.loop) {
      u(l, !1), u(p, !1);
      return;
    }
    u(l, e.isBeginning && !e.params.rewind), u(p, e.isEnd && !e.params.rewind);
  }
  function w(p) {
    p.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), d("navigationPrev"));
  }
  function B(p) {
    p.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), d("navigationNext"));
  }
  function S() {
    const p = e.params.navigation;
    if (e.params.navigation = W(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(p.nextEl || p.prevEl)) return;
    let l = a(p.nextEl), g = a(p.prevEl);
    Object.assign(e.navigation, {
      nextEl: l,
      prevEl: g
    }), l = E(l), g = E(g);
    const f = (i, r) => {
      i && i.addEventListener("click", r === "next" ? B : w), !e.enabled && i && i.classList.add(...p.lockClass.split(" "));
    };
    l.forEach((i) => f(i, "next")), g.forEach((i) => f(i, "prev"));
  }
  function v() {
    let {
      nextEl: p,
      prevEl: l
    } = e.navigation;
    p = E(p), l = E(l);
    const g = (f, i) => {
      f.removeEventListener("click", i === "next" ? B : w), f.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    p.forEach((f) => g(f, "next")), l.forEach((f) => g(f, "prev"));
  }
  t("init", () => {
    e.params.navigation.enabled === !1 ? k() : (S(), m());
  }), t("toEdge fromEdge lock unlock", () => {
    m();
  }), t("destroy", () => {
    v();
  }), t("enable disable", () => {
    let {
      nextEl: p,
      prevEl: l
    } = e.navigation;
    if (p = E(p), l = E(l), e.enabled) {
      m();
      return;
    }
    [...p, ...l].filter((g) => !!g).forEach((g) => g.classList.add(e.params.navigation.lockClass));
  }), t("click", (p, l) => {
    let {
      nextEl: g,
      prevEl: f
    } = e.navigation;
    g = E(g), f = E(f);
    const i = l.target;
    let r = f.includes(i) || g.includes(i);
    if (e.isElement && !r) {
      const o = l.path || l.composedPath && l.composedPath();
      o && (r = o.find((c) => g.includes(c) || f.includes(c)));
    }
    if (e.params.navigation.hideOnClick && !r) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === i || e.pagination.el.contains(i))) return;
      let o;
      g.length ? o = g[0].classList.contains(e.params.navigation.hiddenClass) : f.length && (o = f[0].classList.contains(e.params.navigation.hiddenClass)), d(o === !0 ? "navigationShow" : "navigationHide"), [...g, ...f].filter((c) => !!c).forEach((c) => c.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const h = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), S(), m();
  }, k = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), v();
  };
  Object.assign(e.navigation, {
    enable: h,
    disable: k,
    update: m,
    init: S,
    destroy: v
  });
}
function j(n) {
  return n === void 0 && (n = ""), `.${n.trim().replace(/([\.:!+\/()[\]])/g, "\\$1").replace(/ /g, ".")}`;
}
function te(n) {
  let {
    swiper: e,
    extendParams: s,
    on: t,
    emit: d
  } = n;
  const a = "swiper-pagination";
  s({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (i) => i,
      formatFractionTotal: (i) => i,
      bulletClass: `${a}-bullet`,
      bulletActiveClass: `${a}-bullet-active`,
      modifierClass: `${a}-`,
      currentClass: `${a}-current`,
      totalClass: `${a}-total`,
      hiddenClass: `${a}-hidden`,
      progressbarFillClass: `${a}-progressbar-fill`,
      progressbarOppositeClass: `${a}-progressbar-opposite`,
      clickableClass: `${a}-clickable`,
      lockClass: `${a}-lock`,
      horizontalClass: `${a}-horizontal`,
      verticalClass: `${a}-vertical`,
      paginationDisabledClass: `${a}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let u, m = 0;
  function w() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function B(i, r) {
    const {
      bulletActiveClass: o
    } = e.params.pagination;
    i && (i = i[`${r === "prev" ? "previous" : "next"}ElementSibling`], i && (i.classList.add(`${o}-${r}`), i = i[`${r === "prev" ? "previous" : "next"}ElementSibling`], i && i.classList.add(`${o}-${r}-${r}`)));
  }
  function S(i, r, o) {
    if (i = i % o, r = r % o, r === i + 1)
      return "next";
    if (r === i - 1)
      return "previous";
  }
  function v(i) {
    const r = i.target.closest(j(e.params.pagination.bulletClass));
    if (!r)
      return;
    i.preventDefault();
    const o = I(r) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === o) return;
      const c = S(e.realIndex, o, e.slides.length);
      c === "next" ? e.slideNext() : c === "previous" ? e.slidePrev() : e.slideToLoop(o);
    } else
      e.slideTo(o);
  }
  function h() {
    const i = e.rtl, r = e.params.pagination;
    if (w()) return;
    let o = e.pagination.el;
    o = E(o);
    let c, C;
    const M = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, Y = e.params.loop ? Math.ceil(M / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (C = e.previousRealIndex || 0, c = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (c = e.snapIndex, C = e.previousSnapIndex) : (C = e.previousIndex || 0, c = e.activeIndex || 0), r.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const A = e.pagination.bullets;
      let L, b, D;
      if (r.dynamicBullets && (u = _(A[0], e.isHorizontal() ? "width" : "height"), o.forEach((x) => {
        x.style[e.isHorizontal() ? "width" : "height"] = `${u * (r.dynamicMainBullets + 4)}px`;
      }), r.dynamicMainBullets > 1 && C !== void 0 && (m += c - (C || 0), m > r.dynamicMainBullets - 1 ? m = r.dynamicMainBullets - 1 : m < 0 && (m = 0)), L = Math.max(c - m, 0), b = L + (Math.min(A.length, r.dynamicMainBullets) - 1), D = (b + L) / 2), A.forEach((x) => {
        const y = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((z) => `${r.bulletActiveClass}${z}`)].map((z) => typeof z == "string" && z.includes(" ") ? z.split(" ") : z).flat();
        x.classList.remove(...y);
      }), o.length > 1)
        A.forEach((x) => {
          const y = I(x);
          y === c ? x.classList.add(...r.bulletActiveClass.split(" ")) : e.isElement && x.setAttribute("part", "bullet"), r.dynamicBullets && (y >= L && y <= b && x.classList.add(...`${r.bulletActiveClass}-main`.split(" ")), y === L && B(x, "prev"), y === b && B(x, "next"));
        });
      else {
        const x = A[c];
        if (x && x.classList.add(...r.bulletActiveClass.split(" ")), e.isElement && A.forEach((y, z) => {
          y.setAttribute("part", z === c ? "bullet-active" : "bullet");
        }), r.dynamicBullets) {
          const y = A[L], z = A[b];
          for (let H = L; H <= b; H += 1)
            A[H] && A[H].classList.add(...`${r.bulletActiveClass}-main`.split(" "));
          B(y, "prev"), B(z, "next");
        }
      }
      if (r.dynamicBullets) {
        const x = Math.min(A.length, r.dynamicMainBullets + 4), y = (u * x - u) / 2 - D * u, z = i ? "right" : "left";
        A.forEach((H) => {
          H.style[e.isHorizontal() ? z : "top"] = `${y}px`;
        });
      }
    }
    o.forEach((A, L) => {
      if (r.type === "fraction" && (A.querySelectorAll(j(r.currentClass)).forEach((b) => {
        b.textContent = r.formatFractionCurrent(c + 1);
      }), A.querySelectorAll(j(r.totalClass)).forEach((b) => {
        b.textContent = r.formatFractionTotal(Y);
      })), r.type === "progressbar") {
        let b;
        r.progressbarOpposite ? b = e.isHorizontal() ? "vertical" : "horizontal" : b = e.isHorizontal() ? "horizontal" : "vertical";
        const D = (c + 1) / Y;
        let x = 1, y = 1;
        b === "horizontal" ? x = D : y = D, A.querySelectorAll(j(r.progressbarFillClass)).forEach((z) => {
          z.style.transform = `translate3d(0,0,0) scaleX(${x}) scaleY(${y})`, z.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      r.type === "custom" && r.renderCustom ? (O(A, r.renderCustom(e, c + 1, Y)), L === 0 && d("paginationRender", A)) : (L === 0 && d("paginationRender", A), d("paginationUpdate", A)), e.params.watchOverflow && e.enabled && A.classList[e.isLocked ? "add" : "remove"](r.lockClass);
    });
  }
  function k() {
    const i = e.params.pagination;
    if (w()) return;
    const r = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let o = e.pagination.el;
    o = E(o);
    let c = "";
    if (i.type === "bullets") {
      let C = e.params.loop ? Math.ceil(r / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && C > r && (C = r);
      for (let M = 0; M < C; M += 1)
        i.renderBullet ? c += i.renderBullet.call(e, M, i.bulletClass) : c += `<${i.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${i.bulletClass}"></${i.bulletElement}>`;
    }
    i.type === "fraction" && (i.renderFraction ? c = i.renderFraction.call(e, i.currentClass, i.totalClass) : c = `<span class="${i.currentClass}"></span> / <span class="${i.totalClass}"></span>`), i.type === "progressbar" && (i.renderProgressbar ? c = i.renderProgressbar.call(e, i.progressbarFillClass) : c = `<span class="${i.progressbarFillClass}"></span>`), e.pagination.bullets = [], o.forEach((C) => {
      i.type !== "custom" && O(C, c || ""), i.type === "bullets" && e.pagination.bullets.push(...C.querySelectorAll(j(i.bulletClass)));
    }), i.type !== "custom" && d("paginationRender", o[0]);
  }
  function p() {
    e.params.pagination = W(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const i = e.params.pagination;
    if (!i.el) return;
    let r;
    typeof i.el == "string" && e.isElement && (r = e.el.querySelector(i.el)), !r && typeof i.el == "string" && (r = [...document.querySelectorAll(i.el)]), r || (r = i.el), !(!r || r.length === 0) && (e.params.uniqueNavElements && typeof i.el == "string" && Array.isArray(r) && r.length > 1 && (r = [...e.el.querySelectorAll(i.el)], r.length > 1 && (r = r.find((o) => N(o, ".swiper")[0] === e.el))), Array.isArray(r) && r.length === 1 && (r = r[0]), Object.assign(e.pagination, {
      el: r
    }), r = E(r), r.forEach((o) => {
      i.type === "bullets" && i.clickable && o.classList.add(...(i.clickableClass || "").split(" ")), o.classList.add(i.modifierClass + i.type), o.classList.add(e.isHorizontal() ? i.horizontalClass : i.verticalClass), i.type === "bullets" && i.dynamicBullets && (o.classList.add(`${i.modifierClass}${i.type}-dynamic`), m = 0, i.dynamicMainBullets < 1 && (i.dynamicMainBullets = 1)), i.type === "progressbar" && i.progressbarOpposite && o.classList.add(i.progressbarOppositeClass), i.clickable && o.addEventListener("click", v), e.enabled || o.classList.add(i.lockClass);
    }));
  }
  function l() {
    const i = e.params.pagination;
    if (w()) return;
    let r = e.pagination.el;
    r && (r = E(r), r.forEach((o) => {
      o.classList.remove(i.hiddenClass), o.classList.remove(i.modifierClass + i.type), o.classList.remove(e.isHorizontal() ? i.horizontalClass : i.verticalClass), i.clickable && (o.classList.remove(...(i.clickableClass || "").split(" ")), o.removeEventListener("click", v));
    })), e.pagination.bullets && e.pagination.bullets.forEach((o) => o.classList.remove(...i.bulletActiveClass.split(" ")));
  }
  t("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const i = e.params.pagination;
    let {
      el: r
    } = e.pagination;
    r = E(r), r.forEach((o) => {
      o.classList.remove(i.horizontalClass, i.verticalClass), o.classList.add(e.isHorizontal() ? i.horizontalClass : i.verticalClass);
    });
  }), t("init", () => {
    e.params.pagination.enabled === !1 ? f() : (p(), k(), h());
  }), t("activeIndexChange", () => {
    typeof e.snapIndex > "u" && h();
  }), t("snapIndexChange", () => {
    h();
  }), t("snapGridLengthChange", () => {
    k(), h();
  }), t("destroy", () => {
    l();
  }), t("enable disable", () => {
    let {
      el: i
    } = e.pagination;
    i && (i = E(i), i.forEach((r) => r.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), t("lock unlock", () => {
    h();
  }), t("click", (i, r) => {
    const o = r.target, c = E(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && c && c.length > 0 && !o.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && o === e.navigation.nextEl || e.navigation.prevEl && o === e.navigation.prevEl)) return;
      const C = c[0].classList.contains(e.params.pagination.hiddenClass);
      d(C === !0 ? "paginationShow" : "paginationHide"), c.forEach((M) => M.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const g = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: i
    } = e.pagination;
    i && (i = E(i), i.forEach((r) => r.classList.remove(e.params.pagination.paginationDisabledClass))), p(), k(), h();
  }, f = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: i
    } = e.pagination;
    i && (i = E(i), i.forEach((r) => r.classList.add(e.params.pagination.paginationDisabledClass))), l();
  };
  Object.assign(e.pagination, {
    enable: g,
    disable: f,
    render: k,
    update: h,
    init: p,
    destroy: l
  });
}
class re {
  constructor() {
    this.name = "swiper", this.eventHandlers = /* @__PURE__ */ new Map();
  }
  /**
   * 初始化 Swiper 适配器
   *
   * @param container - 容器元素
   * @param options - Swiper 选项
   */
  async initialize(e, s) {
    try {
      if (this.swiper && await this.destroy(), this.createSwiperStructure(e), !this.swiperContainer || !this.swiperWrapper)
        throw new Error("Swiper container not created");
      const t = {
        // 默认配置
        direction: "horizontal",
        loop: !1,
        speed: 300,
        spaceBetween: 30,
        slidesPerView: 1,
        //
        slidesPerGroup: 1,
        // 确保每次导航只移动一个 slide
        // 注册模块
        modules: [ie, te, ee],
        // 导航配置 - 使用元素引用而不是选择器，确保在 Vue 组件中也能正常工作
        navigation: {
          nextEl: this.nextButton || void 0,
          prevEl: this.prevButton || void 0
        },
        // 分页配置 - 使用元素引用而不是选择器
        pagination: {
          el: this.paginationEl || void 0,
          clickable: !0
        },
        // 键盘控制配置
        keyboard: {
          enabled: !0,
          onlyInViewport: !0
        },
        // 用户自定义配置（会覆盖上面的默认配置）
        ...s?.swiperConfig
      };
      this.swiper = new Q(this.swiperContainer, t), this.setupEventListeners(), this.emit("ready");
    } catch (t) {
      const d = t instanceof Error ? t.message : String(t);
      throw this.emit("error", { message: d }), new Error(`Failed to initialize SwiperAdapter: ${d}`);
    }
  }
  /**
   * 渲染幻灯片
   *
   * @param slides - 幻灯片定义数组
   */
  async render(e) {
    if (!this.swiperWrapper || !this.swiper)
      throw new Error("SwiperAdapter not initialized");
    try {
      this.swiperWrapper.innerHTML = "";
      for (const s of e) {
        const t = await this.renderSlide(s);
        this.swiperWrapper.appendChild(t);
      }
      this.swiper.update(), this.emit("slideRendered", { totalSlides: e.length });
    } catch (s) {
      const t = s instanceof Error ? s.message : String(s);
      throw this.emit("error", { message: t }), new Error(`Failed to render slides: ${t}`);
    }
  }
  /**
   * 销毁适配器
   */
  async destroy() {
    this.swiper && this.slideChangeHandler && (this.swiper.off("slideChange", this.slideChangeHandler), this.slideChangeHandler = void 0), this.swiper && (this.swiper.destroy(!0, !0), this.swiper = void 0), this.swiperContainer && (this.swiperContainer.innerHTML = "", this.swiperContainer = void 0), this.swiperWrapper = void 0, this.eventHandlers.clear();
  }
  /**
   * 导航到指定幻灯片
   *
   * @param index - 幻灯片索引
   */
  navigateTo(e) {
    if (!this.swiper)
      throw new Error("SwiperAdapter not initialized");
    this.swiper.slideTo(e);
  }
  /**
   * 获取当前幻灯片索引
   */
  getCurrentIndex() {
    return this.swiper ? this.swiper.activeIndex : 0;
  }
  /**
   * 获取幻灯片总数
   */
  getTotalSlides() {
    return this.swiper ? this.swiper.slides.length : 0;
  }
  /**
   * 更新指定幻灯片
   *
   * @param index - 幻灯片索引
   * @param slide - 新的幻灯片定义
   */
  async updateSlide(e, s) {
    if (!this.swiperWrapper || !this.swiper)
      throw new Error("SwiperAdapter not initialized");
    try {
      const d = this.swiperWrapper.querySelectorAll(".swiper-slide")[e];
      if (!d)
        throw new Error(`Slide at index ${e} not found`);
      const a = await this.renderSlide(s);
      d.replaceWith(a), this.swiper.update();
    } catch (t) {
      const d = t instanceof Error ? t.message : String(t);
      throw this.emit("error", { message: d }), new Error(`Failed to update slide: ${d}`);
    }
  }
  /**
   * 注册事件监听器
   *
   * @param event - 事件类型
   * @param handler - 事件处理器
   */
  on(e, s) {
    this.eventHandlers.has(e) || this.eventHandlers.set(e, /* @__PURE__ */ new Set()), this.eventHandlers.get(e).add(s);
  }
  /**
   * 移除事件监听器
   *
   * @param event - 事件类型
   * @param handler - 事件处理器
   */
  off(e, s) {
    const t = this.eventHandlers.get(e);
    t && t.delete(s);
  }
  /**
   * 创建 Swiper DOM 结构
   *
   * @param container - 容器元素（这是 runner.ts 创建的独立 div，Swiper 会接管它）
   */
  createSwiperStructure(e) {
    e.className = "swiper";
    const s = document.createElement("div");
    s.className = "swiper-wrapper", this.prevButton = document.createElement("div"), this.prevButton.className = "swiper-button-prev", this.nextButton = document.createElement("div"), this.nextButton.className = "swiper-button-next", this.paginationEl = document.createElement("div"), this.paginationEl.className = "swiper-pagination", e.appendChild(s), e.appendChild(this.prevButton), e.appendChild(this.nextButton), e.appendChild(this.paginationEl), this.swiperContainer = e, this.swiperWrapper = s;
  }
  /**
   * 设置 Swiper 事件监听
   */
  setupEventListeners() {
    this.swiper && (this.slideChangeHandler && this.swiper.off("slideChange", this.slideChangeHandler), this.slideChangeHandler = () => {
      const e = this.swiper.activeIndex, s = this.swiper.previousIndex;
      this.emit("slideChanged", {
        index: e,
        previousIndex: s,
        from: s,
        to: e
      });
    }, this.swiper.on("slideChange", this.slideChangeHandler));
  }
  /**
   * 渲染单张幻灯片
   *
   * @param slide - 幻灯片定义
   * @returns slide 元素
   */
  async renderSlide(e) {
    const s = document.createElement("div");
    if (s.className = "swiper-slide", e.behavior?.transition) {
      const t = this.mapTransition(e.behavior.transition.type);
      t && s.classList.add(`slide-transition-${t}`);
    }
    if (e.content.type === "dynamic") {
      const t = await this.renderDynamicContent(e.content.component, e.content.props);
      s.appendChild(t);
    } else {
      const t = this.renderTextContent(e.content.lines);
      s.appendChild(t);
    }
    return s;
  }
  /**
   * 渲染动态内容（Web Component）
   *
   * 支持所有 Web Components，包括：
   * - 标准 Web Components（原生 Custom Elements）
   * - wsx 组件（编译为标准 Web Components）
   * - 其他框架的 Web Components（Vue、React、Angular 等）
   *
   * @param component - 组件名称
   * @param props - 组件属性
   * @returns 组件元素
   */
  async renderDynamicContent(e, s) {
    const t = document.createElement(e);
    for (const [d, a] of Object.entries(s))
      typeof a == "string" || typeof a == "number" ? t.setAttribute(d, String(a)) : typeof a == "boolean" ? a && t.setAttribute(d, "") : t[d] = a;
    return t;
  }
  /**
   * 渲染文本内容
   *
   * 支持以下格式：
   * - # 标题 -> h1
   * - ## 标题 -> h2
   * - ### 标题 -> h3
   * - ![alt](url) -> img
   * - - 列表项 -> ul/li
   * - 普通文本 -> p
   *
   * @param lines - 文本行数组
   * @returns 内容容器元素
   */
  renderTextContent(e) {
    const s = document.createElement("div");
    s.className = "slide-content";
    let t = null;
    for (const d of e) {
      const a = d.trim();
      if (!a) {
        t = null;
        continue;
      }
      if (a.startsWith("# ")) {
        t = null;
        const w = document.createElement("h1");
        w.textContent = a.substring(2), s.appendChild(w);
        continue;
      }
      if (a.startsWith("## ")) {
        t = null;
        const w = document.createElement("h2");
        w.textContent = a.substring(3), s.appendChild(w);
        continue;
      }
      if (a.startsWith("### ")) {
        t = null;
        const w = document.createElement("h3");
        w.textContent = a.substring(4), s.appendChild(w);
        continue;
      }
      const u = a.match(/^!\[(.*?)\]\((.*?)\)$/);
      if (u) {
        t = null;
        const w = document.createElement("img");
        w.alt = u[1], w.src = u[2], w.style.maxWidth = "80%", w.style.maxHeight = "500px", s.appendChild(w);
        continue;
      }
      if (a.startsWith("- ")) {
        t || (t = document.createElement("ul"), s.appendChild(t));
        const w = document.createElement("li");
        w.textContent = a.substring(2), t.appendChild(w);
        continue;
      }
      t = null;
      const m = document.createElement("p");
      m.textContent = a, s.appendChild(m);
    }
    return s;
  }
  /**
   * 映射 Slide DSL 过渡效果到 Swiper 过渡效果
   *
   * @param transition - Slide DSL 过渡效果
   * @returns Swiper 过渡效果类名（用于 CSS）
   */
  mapTransition(e) {
    return !e || e === "none" ? null : e;
  }
  /**
   * 触发事件
   *
   * @param event - 事件类型
   * @param data - 事件数据
   */
  emit(e, s) {
    const t = this.eventHandlers.get(e);
    if (t)
      for (const d of t)
        try {
          d(s);
        } catch (a) {
          console.error(`Error in ${e} handler:`, a);
        }
  }
}
const se = '@font-face{font-family:swiper-icons;src:url(data:application/font-woff;charset=utf-8;base64,\\ d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA);font-weight:400;font-style:normal}:root{--swiper-theme-color: #007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function, initial);box-sizing:content-box}.swiper-android .swiper-slide,.swiper-ios .swiper-slide,.swiper-wrapper{transform:translateZ(0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-slide,.swiper-3d .swiper-cube-shadow{transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper:before{content:"";flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper:before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper:before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-slide-shadow-bottom{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:#00000026}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,#00000080,#0000)}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color, var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color: #fff}.swiper-lazy-preloader-black{--swiper-preloader-color: #000}@keyframes swiper-preloader-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.swiper-virtual .swiper-slide{-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper:after{content:"";position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper:after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper:after{width:1px;height:var(--swiper-virtual-size)}:root{--swiper-navigation-size: 44px}.swiper-button-prev,.swiper-button-next{position:absolute;top:var(--swiper-navigation-top-offset, 50%);width:calc(var(--swiper-navigation-size) / 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size) / 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color, var(--swiper-theme-color))}.swiper-button-prev.swiper-button-disabled,.swiper-button-next.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-prev.swiper-button-hidden,.swiper-button-next.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-prev,.swiper-navigation-disabled .swiper-button-next{display:none!important}.swiper-button-prev svg,.swiper-button-next svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-prev svg,.swiper-rtl .swiper-button-next svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset, 10px);right:auto}.swiper-button-lock{display:none}.swiper-button-prev:after,.swiper-button-next:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;font-variant:initial;line-height:1}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:"prev"}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset, 10px);left:auto}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:"next"}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translateZ(0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-pagination-fraction,.swiper-pagination-custom,.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal{bottom:var(--swiper-pagination-bottom, 8px);top:var(--swiper-pagination-top, auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));height:var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius, 50%);background:var(--swiper-pagination-bullet-inactive-color, #000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color, var(--swiper-theme-color))}.swiper-vertical>.swiper-pagination-bullets,.swiper-pagination-vertical.swiper-pagination-bullets{right:var(--swiper-pagination-right, 8px);left:var(--swiper-pagination-left, auto);top:50%;transform:translate3d(0,-50%,0)}.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap, 6px) 0;display:block}.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap, 4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translate(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color, inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color, rgba(0, 0, 0, .25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color, var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size, 4px);left:0;top:0}.swiper-vertical>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite{width:var(--swiper-pagination-progressbar-size, 4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius, 10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color, rgba(0, 0, 0, .1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset, 1%);bottom:var(--swiper-scrollbar-bottom, 4px);top:var(--swiper-scrollbar-top, auto);z-index:50;height:var(--swiper-scrollbar-size, 4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%))}.swiper-vertical>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-vertical{position:absolute;left:var(--swiper-scrollbar-left, auto);right:var(--swiper-scrollbar-right, 4px);top:var(--swiper-scrollbar-sides-offset, 1%);z-index:50;width:var(--swiper-scrollbar-size, 4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color, rgba(0, 0, 0, .5));border-radius:var(--swiper-scrollbar-border-radius, 10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>img,.swiper-zoom-container>svg,.swiper-zoom-container>canvas{max-width:100%;max-height:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-fade .swiper-slide-active,.swiper-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper.swiper-cube{overflow:visible}.swiper-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-cube.swiper-rtl .swiper-slide{transform-origin:100% 0}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-next,.swiper-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:"";background:#000;position:absolute;inset:0;filter:blur(50px)}.swiper-cube .swiper-slide-next+.swiper-slide{pointer-events:auto;visibility:visible}.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-top,.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-bottom,.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-left,.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-right{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper.swiper-flip{overflow:visible}.swiper-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-flip .swiper-slide-active,.swiper-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-top,.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-bottom,.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-left,.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-right{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-creative .swiper-slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper.swiper-cards{overflow:visible}.swiper-cards .swiper-slide{transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}', ne = ".swiper{width:100%;height:100%;--slidejs-swiper-navigation-color: var(--slidejs-navigation-color, #007aff);--slidejs-swiper-pagination-color: var(--slidejs-pagination-color, #007aff);--slidejs-swiper-pagination-bullet-active-color: var(--slidejs-pagination-active-color, #007aff);--slidejs-swiper-scrollbar-bg: var(--slidejs-scrollbar-bg, rgba(0, 0, 0, .1));--slidejs-swiper-scrollbar-drag-bg: var(--slidejs-scrollbar-drag-bg, rgba(0, 0, 0, .5));--swiper-navigation-color: var(--slidejs-navigation-color, #007aff);--swiper-pagination-color: var(--slidejs-pagination-color, #007aff);--swiper-pagination-bullet-active-color: var(--slidejs-pagination-active-color, #007aff);--swiper-theme-color: var(--slidejs-navigation-color, #007aff)}.swiper .swiper-button-next,.swiper .swiper-button-prev{color:var(--swiper-navigation-color, var(--slidejs-swiper-navigation-color, #007aff))!important}.swiper .swiper-pagination-bullet{background-color:var( --swiper-pagination-color, var(--slidejs-swiper-pagination-color, #007aff) )!important}.swiper .swiper-pagination-bullet-active{background-color:var( --swiper-pagination-bullet-active-color, var(--slidejs-swiper-pagination-bullet-active-color, #007aff) )!important}.swiper .swiper-scrollbar{background:var(--slidejs-swiper-scrollbar-bg, rgba(0, 0, 0, .1))!important}.swiper .swiper-scrollbar-drag{background:var(--slidejs-swiper-scrollbar-drag-bg, rgba(0, 0, 0, .5))!important}.swiper-slide{display:flex;align-items:center;justify-content:center;width:100%;height:100%;background:var(--slidejs-background-color, #fff);padding:2rem;box-sizing:border-box}.slide-content{width:100%;text-align:center}.slide-content h1{font-size:3rem;margin-bottom:1rem;color:var(--slidejs-heading-color, #333)}.slide-content h2{font-size:2rem;margin-bottom:1rem;color:var(--slidejs-heading-color, #666)}.slide-content h3{font-size:1.5rem;margin-bottom:.5rem;color:var(--slidejs-heading-color, #666)}.slide-content p{font-size:1.2rem;line-height:1.6;color:var(--slidejs-text-color, #555);margin-bottom:1rem}.slide-content ul{text-align:left;display:inline-block;font-size:1.2rem;line-height:1.8;color:var(--slidejs-text-color, #555)}.slide-content li{margin-bottom:.5rem}.slide-content img{border-radius:8px;box-shadow:0 4px 12px #0000001a}.swiper-button-next:after,.swiper-button-prev:after{font-size:24px}.swiper-pagination-bullet{opacity:.5}.swiper-pagination-bullet-active{opacity:1}";
async function pe(n, e, s) {
  const t = await R(n), d = q(t), a = "swiper-bundle-styles";
  if (!document.head.querySelector(`#${a}`)) {
    const v = document.createElement("style");
    v.id = a, v.textContent = se, document.head.appendChild(v);
  }
  let u;
  if (typeof s.container == "string") {
    const v = document.querySelector(s.container);
    if (!v)
      throw new Error(`Container not found: ${s.container}`);
    u = v;
  } else
    u = s.container;
  const m = "slidejs-runner-swiper-styles";
  if (!u.querySelector(`#${m}`)) {
    const v = document.createElement("style");
    v.id = m, v.textContent = ne, u.appendChild(v);
  }
  const w = document.createElement("div");
  u.appendChild(w);
  const B = new re(), S = new Z({
    container: w,
    adapter: B,
    adapterOptions: {
      swiperConfig: s.swiperOptions
    }
  });
  return await S.run(d, e), S;
}
export {
  re as SwiperAdapter,
  pe as createSlideRunner
};
//# sourceMappingURL=index.mjs.map
